import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";
import RequesterPage from "./pages/RequesterPage";
import ApproverPage from "./pages/ApproverPage";
import FinancePage from "./pages/FinancePage";
import StoresPage from "./pages/StoresPage";

import "./App.css";
import "./styles/DesignSystem.css";
import { getHomeRoute, hasRight, isAuthenticated, readStoredUser } from "./utils/routing";

/* =========================================
   ROLE-BASED HOME ROUTE
========================================= */
const ProtectedRoute = ({ children, right }) => {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  const user = readStoredUser();
  return !right || hasRight(user, right) ? children : <Navigate to={getHomeRoute(user)} replace />;
};

function AppLayout() {
  const location = useLocation();

  const hideNavbar = location.pathname === "/login";

  return (
    <div className="app-layout">
      <div className="main-content">
        {!hideNavbar && <Navbar />}

        <div className="page-content">
          <Routes>
            {/* ROOT */}
            <Route
              path="/"
              element={
                <Navigate
                  to={getHomeRoute()}
                  replace
                />
              }
            />

            {/* LOGIN */}
            <Route
              path="/login"
              element={<LoginPage />}
            />

            {/* DASHBOARD */}
            <Route
              path="/dashboard"
              element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
            />

            {/* ROLE PAGES */}
            <Route
              path="/admin"
              element={<ProtectedRoute right="admin"><AdminPage /></ProtectedRoute>}
            />

            <Route
              path="/requester"
              element={<ProtectedRoute right="request"><RequesterPage /></ProtectedRoute>}
            />

            <Route
              path="/approver"
              element={<ProtectedRoute right="approve"><ApproverPage /></ProtectedRoute>}
            />

            <Route
              path="/finance"
              element={<ProtectedRoute right="finance"><FinancePage /></ProtectedRoute>}
            />

            <Route
              path="/stores"
              element={<ProtectedRoute right="stores"><StoresPage /></ProtectedRoute>}
            />
            <Route path="*" element={<Navigate to={getHomeRoute()} replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
